import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on route change, or to the #hash target once it renders.
export default function useScrollOnNavigate() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) { window.scrollTo(0, 0); return; }
    const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 60);
    return () => clearTimeout(t);
  }, [pathname, hash]);
}
